// import Masonry from 'masonry-layout';
// export default {
//   init() {
//       $(window).on('load', function(){
//           var msnry = new Masonry( '.masonry-layout', {
//               // columnWidth: 200,
//               itemSelector: '.album',
//           });
//           $(document).on('click','.masonry-filter', function(e){
//               e.preventDefault();
//               $('.masonry-filters .masonry-filter').removeClass('active');
//               $(this).addClass('active');
//               var filter = $(this).attr('data-filter');
//               if( filter === '*' ){
//                   $('.masonry-layout .album').fadeIn('fast', function(){
//                       msnry.layout();
//                   });
//               }else{
//                   $('.album.'+filter).fadeIn('fast', function(){
//                       msnry.layout();
//                   });
//                   $('.album:not(.'+filter+')').fadeOut('fast', function(){
//                       msnry.layout();
//                   });
//               }

//           });
//       });

//   },
//   finalize() {


//   },
// };



// WEBPACK FOOTER //
// ./scripts/routes/templateAlbums.js